/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_TransparencyInputs */

const de_commons_footer_transparency = /** @type {(inputs: Commons_Footer_TransparencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparenz`)
};

/** @type {(inputs: Commons_Footer_TransparencyInputs) => LocalizedString} */
const en_commons_footer_transparency = de_commons_footer_transparency;

/**

* @param {Commons_Footer_TransparencyInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_transparency = /** @type {((inputs?: Commons_Footer_TransparencyInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_TransparencyInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_transparency(inputs)
	return en_commons_footer_transparency(inputs)
});